(function($){
  $(function(){
      var $cardSlider = $('.zn-card-slider > .zn-stage');

      if ($cardSlider.length) {
          $cardSlider.filter('[data-wrap-slides="true"]').children().wrap( "<li></li>" );

          $cardSlider.find('li').wrapAll('<ul></ul>')

          imagesLoaded('.zn-card-slider', function(){
            $cardSlider.each(function() {
              var $this = $(this),
                  currentSlide = 1,
                  requestedAmount = $this.attr('data-slide-amount').replace(/\D/g,''),
                  slideAmountBreaks = {
                    '1': {
                      'full': 1,
                      'large': 1,
                      'medium': 1,
                      'small': 1
                    },
                    '2': {
                      'full': 2,
                      'large': 2,
                      'medium': 1,
                      'small': 1
                    },
                    '3': {
                      'full': 3,
                      'large': 2,
                      'medium': 2,
                      'small': 1
                    },
                    '4': {
                      'full': 4,
                      'large': 3,
                      'medium': 2,
                      'small': 2
                    },
                    '5': {
                      'full': 5,
                      'large': 4,
                      'medium': 3,
                      'small': 2
                    },
                    '6': {
                      'full': 6,
                      'large': 4,
                      'medium': 3,
                      'small': 2
                    }
                  },
                  slideAmount = ((requestedAmount in slideAmountBreaks) ? requestedAmount : '4'),
                  controlsVisibility = function($slider,size,slideAmountBreaks,slideAmount){
                    if(slideAmountBreaks[slideAmount][size] >= $slider.getValue('totalSlides')){
                      $slider.parent().addClass('zn-hide-controls');
                    }else{
                      $slider.parent().removeClass('zn-hide-controls');
                    }
                  },
                  slider = $this.sudoSlider({
                      continuous:true,
                      responsive:true,
                      auto:false,
                      speed:500,
                      prevNext:true,
                      numeric:'pages',
                      moveCount: 1,
                      slideCount: slideAmountBreaks[slideAmount]['small'],
                      initCallback: function () {
                          setTimeout(function() {
                            var slideCount = slider.getOption("slideCount"),
                                currentSlide = slider.getValue('currentSlide');
                                $controls = slider.next('.controls');
                            
                            slider.getSlide(currentSlide).removeClass('zn-active').siblings().removeClass('zn-active');
                            slider.getSlide(currentSlide).addClass('zn-active').nextAll("*:lt(" + (slideCount-1) + ")").addClass('zn-active');
                            
                            slider.find('.slidesContainer').attr('aria-live', 'polite').attr('role', 'region');

                            $controls.find('.prevBtn').attr('aria-label', 'Navigate to previous slide').attr('title', 'Previous Slide');
                            $controls.find('.nextBtn').attr('aria-label', 'Navigate to next slide').attr('title', 'Next Slide');;

                            $controls.find('ol li a').each(function(){
                                var $this = $(this),
                                    target = $this.parent('li').attr('data-target');

                                $this.attr('aria-label', 'Navigate to slide ' + target).attr('title', 'Slide ' + target);
                            });
                          }, 500);   
                      },
                      beforeAnimation: function (t) {
                          slider.getSlide(t).removeClass('zn-active').siblings().removeClass('zn-active');
                      },
                      afterAnimation: function (t) {
                          var slideCount = slider.getOption("slideCount");
                          slider.getSlide(t).addClass('zn-active').nextAll("*:lt(" + (slideCount-1) + ")").addClass('zn-active'); 
                      }
                    }),
                  moves = [
                      {
                        min:0,
                        max:599,
                        enter: function() {
                          slider.setOption('slideCount',slideAmountBreaks[slideAmount]['small']);

                          slider.setOption('moveCount',slideAmountBreaks[slideAmount]['small']);

                          slider.destroy();
                          
                          controlsVisibility(slider,'small',slideAmountBreaks,slideAmount);

                          slider.init();
                        },
                        exit: function() { slider.setOption('moveCount',1); slider.destroy(); }
                      },
                      {
                        min:600,
                        max:1023,
                        enter: function() {
                          slider.setOption('slideCount',slideAmountBreaks[slideAmount]['medium']);

                          slider.setOption('moveCount',slideAmountBreaks[slideAmount]['medium']);
                          
                          slider.destroy();

                          controlsVisibility(slider,'medium',slideAmountBreaks,slideAmount);

                          slider.init();
                        },
                        exit: function() { slider.setOption('moveCount',1); slider.destroy(); }
                      },
                      {
                        min:1024,
                        max:1399,
                        enter: function() {
                          slider.setOption('slideCount',slideAmountBreaks[slideAmount]['large']);

                          slider.setOption('moveCount',slideAmountBreaks[slideAmount]['large']);
                          
                          slider.destroy();

                          controlsVisibility(slider,'large',slideAmountBreaks,slideAmount);

                          slider.init();
                        },
                        exit: function() { slider.setOption('moveCount',1); slider.destroy(); }
                      },
                      {
                        min:1400,
                        max:9999999,
                        enter: function() {
                          slider.setOption('slideCount',slideAmountBreaks[slideAmount]['full']);

                          slider.setOption('moveCount',slideAmountBreaks[slideAmount]['full']);

                          slider.destroy();
                          
                          controlsVisibility(slider,'full',slideAmountBreaks,slideAmount);

                          slider.init();
                        },
                        exit: function() { slider.setOption('moveCount',1); slider.destroy(); }
                      }
                  ];

                  breakdance(moves);
            });
          });  
      }
  });
})($JQ);